// Mock/fallback data for Bohol Cacao Information System

export const adminOffers = [
  {
    id: 'offer-1',
    title: 'Soil Testing Service',
    description: 'Comprehensive soil analysis and recommendations to improve cacao yield.',
    contact: 'admin@bciis.local',
    active: true
  },
  {
    id: 'offer-2',
    title: 'Farmer Training Workshop',
    description: 'Hands-on training on pruning, fermentation and post-harvest handling.',
    contact: 'training@bciis.local',
    active: true
  }
];
